// Generated, DO NOT EDIT MANUALLY.
import { createTypedClient } from '../../../pplx/frontend/api-clients/core/client.js';
export const automationsClient = createTypedClient();
export const createAutomationsClient = (config) => createTypedClient(config);
